export const updateHandler = (registration: ServiceWorkerRegistration) => {
  console.info('Update version');
};
